/**
 * Handles fetch request and fetch errors. If no errors returns response.
 * @param request 
 * @returns 
 */
import environment, { isGuestCheckoutPage } from "../environment";
import { ErrorTypes } from "./error-utils";

export async function getResponseData(request: Request, { retries = 1 } = {}) {
  let response: any;
  let tries = 0;
  let success = false;

  while (!success && tries < retries) {
    response = await fetch(request);
    success = response.ok && response.status >= 200 && response.status <= 299;
    tries += 1;
  }

  const isJson = response.headers.get('content-type')?.includes('application/json');
  const data = isJson ? await response.json() : response.body;

  if (!response.ok) {
    const message = `Failed to ${request.method} ${request.url} with status : ${response.status} ${response.statusText}`;
    console.error(message);
    throw new ApiError(message, data, response.status, response.statusText);
  }

  return data;
}

export function handleApiError(apiError: ApiError) {
  const isGuest = isGuestCheckoutPage()
  if (isGuest) {
    throw apiError;
  } else if (apiError && apiError.responseStatus === 401 && !window.Mhecomm_Editor) {
    window.location.href = environment().loginUrl;
  }
}


export class ApiError extends Error {
  response: any;
  responseStatus: number;
  responseStatusText: string;

  constructor(message: string, response: any, responseStatus: number, responseStatusText: string){
    super();
    this.name = ErrorTypes.ApiError;
    this.message = message;
    this.response = response;
    this.responseStatus= responseStatus;
    this.responseStatusText = responseStatusText;
  }
}


export function addResponseInteceptor(
  onResponse: (
    response: Response,
    fetchInstance: (...args: Parameters<typeof fetch>) => Promise<Response>
  ) => Promise<any>,
  shouldIntercept: (response: Response) => boolean
) {
  const { fetch: originalFetch } = window;
  window.fetch = async (...args: Parameters<typeof fetch>): Promise<Response> => {
    const response = await originalFetch(...args);
    if (shouldIntercept(response)) {
      return await onResponse(response, async function (...fetchArgs: Parameters<typeof fetch>) {
        const [url, requestOptions] = args;
        const [, responseOptions] = fetchArgs;
        return await originalFetch(url, {
          ...requestOptions,
          ...responseOptions,
          headers: {
            ...(requestOptions && requestOptions.headers),
            ...(responseOptions && responseOptions.headers),
          },
        });
      });
    }
    return response;
  };
}